import React, { useCallback, useState } from 'react'
import isProd from '../../../utils/constants/isProd'
import { useDispatch } from 'react-redux'
import { addPartInBasketQuantity, setParts } from '../../table/partsInBasketSlice'

const ButtonBuyQuantityDefault = ({ part, basketInfo, showQuantitySelect = true }) => {
    const dispatch = useDispatch()
    const maxQuantity = part.quantity
    const basketQuantity = basketInfo['quantity']

    const [quantity, setQuantity] = useState(1)

    const buyAction = useCallback(() => {
        if (isProd) {
            const buyUrl = part.buy_url + '&quantity=' + quantity
            const basketQuantityUrl = '/ajax/basket-parts.php?sessid=' + window.BX.bitrix_sessid()
            const basketHeaderUrl = '/ajax/basket_header.php'
            const basketHeaderClass = 'b-top-basket'

            fetch(buyUrl)
                .then(() => fetch(basketHeaderUrl))
                .then((res) => res.text())
                .then((html) => {
                    document.getElementsByClassName(basketHeaderClass)[0].innerHTML = html
                })
                .then(() => fetch(basketQuantityUrl))
                .then((res) => res.json())
                .then(
                    (result) => {
                        if (result.result) {
                            if (typeof window.ym != 'undefined') {
                                window.ym(1848328,'reachGoal','buy_js');
                            } else {
                                console.log('Yandex метрика не инициализирована');
                            }
                            dispatch(setParts(result.data))
                        } else {
                            console.log('Ajax error (buyAction) : ' + result.error)
                        }
                    },
                    (error) => {
                        console.log('Ajax error (buyAction) : ' + error)
                    }
                )
        } else {
            dispatch(addPartInBasketQuantity({ hash: part.basket_hash, quantity: quantity }))
        }
    }, [quantity, part, dispatch])

    const onChange = (e) => {
        let quantity = Number(e.target.value)

        if (quantity <= 0) {
            quantity = 1
        }

        if (quantity > maxQuantity) {
            quantity = maxQuantity
        }

        setQuantity(quantity)
    }
    const increaseQuantity = (e) => setQuantity(quantity < maxQuantity ? quantity + 1 : maxQuantity)
    const decreaseQuantity = (e) => setQuantity(quantity <= 1 ? 1 : quantity - 1)

    return (
        <div className="buying">
            {showQuantitySelect && (
                <div className="buying__quantity">
                    <button className="buying__quantity-dec" onClick={decreaseQuantity}>
                        -
                    </button>
                    <input
                        className="buying__quantity-input"
                        onChange={onChange}
                        type="text"
                        value={quantity}
                    />
                    <button className="buying__quantity-inc" onClick={increaseQuantity}>
                        +
                    </button>
                </div>
            )}
            <div className="buying__button">
                <button
                    className={basketQuantity ? 'button-buy in-basket' : 'button-buy'}
                    onClick={buyAction}
                    disabled={part.price_src <= 0}
                >
                    {basketQuantity > 0 ? (
                        <span className="button-buy__count">{basketQuantity}</span>
                    ) : (
                        <></>
                    )}

                    <svg
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M10.3665 7.66666C10.8665 7.66666 11.3065 7.39333 11.5332 6.98L13.9198 2.65333C14.1665 2.21333 13.8465 1.66666 13.3398 1.66666H3.47317L2.8465 0.333328H0.666504V1.66666H1.99984L4.39984 6.72666L3.49984 8.35333C3.01317 9.24666 3.65317 10.3333 4.6665 10.3333H12.6665V9H4.6665L5.39984 7.66666H10.3665ZM4.1065 2.99999H12.2065L10.3665 6.33333H5.6865L4.1065 2.99999ZM4.6665 11C3.93317 11 3.33984 11.6 3.33984 12.3333C3.33984 13.0667 3.93317 13.6667 4.6665 13.6667C5.39984 13.6667 5.99984 13.0667 5.99984 12.3333C5.99984 11.6 5.39984 11 4.6665 11ZM11.3332 11C10.5998 11 10.0065 11.6 10.0065 12.3333C10.0065 13.0667 10.5998 13.6667 11.3332 13.6667C12.0665 13.6667 12.6665 13.0667 12.6665 12.3333C12.6665 11.6 12.0665 11 11.3332 11Z" />
                    </svg>
                </button>
            </div>
        </div>
    )
}

export default ButtonBuyQuantityDefault
